import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { CommonService } from './common.service';

@Injectable()
export class DashboardService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

  locationVehicle(userAccount, userPass): Promise<any> {
    // console.log('ingresando al servicio : ,  userAccount : ', userAccount, '    userPass : ', userPass);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getVehicleLocation/' + userAccount + '/' + userPass;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        return obj;
      });
  }

  getVehiclesByrute(userAccount, routesId): Promise<any> {
    // console.log('ingresando al servicio : ,  userAccount : ', userAccount, '    userPass : ', userPass);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getVehiclesInTrasitByRoute/' + userAccount + '/' + routesId;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        return obj;
      });
  }

  getParkingWorShop(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getParkingWorShop : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getDataVehiclesParking/' + userAccount + "/" + this.commonService.getUserRole();
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        // console.log('obj : : : : ', obj)
        const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }
  

  getAlertVehicles(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getAlertVehicles : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getAlertVehicles/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        // console.log('obj : : : : ', obj)
        const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getAlertVehicles_rol(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getAlertVehicles : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getAlertVehicles_rol/' + userAccount + "/" + this.commonService.getUserRole();
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        // console.log('obj : : : : ', obj)
        const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getLastAlertVehicles(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getAlertVehicles : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getLastAlertVehicles/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        // console.log('obj : : : : ', obj)
        const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getLastAlertVehicles_rol(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getAlertVehicles : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getLastAlertVehicles_rol/' + userAccount + "/" + this.commonService.getUserRole();
    console.log(url)
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        // console.log('obj : : : : ', obj)
        const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getVehiclesTransit(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getVehiclesTransit : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getVehiclesTransitCompany/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        //const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getTripsInformation(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getVehiclesTransit : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getTotalPassengers/' + userAccount;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        //const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getCaidasInformation(userAccount): Promise<any> {
    console.log('ingresando al servicio : ,  getVehiclesTransit : ', userAccount);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getTotalCaidas/' + userAccount + "/" + this.commonService.getUserRole();
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        //const response = JSON.parse(obj.toString());
        // console.log('response : : : : ', response)
        return response;
      });
  }

  getSingleVehicleLocation(plate): Promise<any> {
    // console.log('ingresando al servicio : ,  userAccount : ', userAccount, '    userPass : ', userPass);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getVehicleLocationByPlate/' + this.commonService.getUserName() + '/' + this.commonService.getUserPass() + "/" + plate;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        return obj;
      });
  }

  getSingleVehicleLocation_inTransit(plate): Promise<any> {
    // console.log('ingresando al servicio : ,  userAccount : ', userAccount, '    userPass : ', userPass);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getVehicleLocationByPlate_InTransit_gps/' + this.commonService.getUserName() + '/' + this.commonService.getUserPass() + "/" + plate;
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        return obj;
      });
  }

  getOutOfTransitVehicles(): Promise<any> {
    // console.log('ingresando al servicio : ,  userAccount : ', userAccount, '    userPass : ', userPass);
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getVehiclesOutOfRoute/' + this.commonService.getUserName()+ "/" + this.commonService.getUserRole(); 
    return this.http.get(url, {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        return obj;
      });
  }



}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/dashboard.service.ts